module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_9-32641bf2080dd9e4046beb90e5dee85c.png";